// eslint-disable-next-line
let baseUrl;
const {
  location: { hostname, origin },
} = window;

if (hostname === 'activity.yinxiang.com') {
  // prod:
  baseUrl = 'https://app.yinxiang.com';
} else if (hostname.indexOf('stage') > -1) {
  // stage:
  const edamHost = hostname.replace('-activity', '');
  baseUrl = `https://${edamHost}`;
} else {
  // dev:
  baseUrl = origin;
}

export { baseUrl };
